export default __webpack_public_path__ + "static/hackerrank-c5bede0098e3bf3a222e85589968e4a3.png";